import * as ACTIONTYPES from '../constants/actiontypes'

import {
  getIsSlideZoomed,
  getIsBookWithText,
  getTextOfTheCurrentFrame,
} from '../selectors/selectors'

import {
  setNextFrame,
  setPreviosFrame,
} from './play-actions';

export const nextPage = () => (dispatch, getState) => {
  const state = getState();
  const isBookWithText = getIsBookWithText(state);
  const textOfTheCurrentFrame = getTextOfTheCurrentFrame(state);
  const isSlideZoomed = getIsSlideZoomed(state);

  if (!isBookWithText || !textOfTheCurrentFrame || isSlideZoomed) {
    dispatch(setNextFrame())
  } else {
    dispatch(nextPieceOfText())
  }
}

export const prevPage = () => (dispatch, getState) => {
  const state = getState();
  const isBookWithText = getIsBookWithText(state);
  const textOfTheCurrentFrame = getTextOfTheCurrentFrame(state);
  const isSlideZoomed = getIsSlideZoomed(state);

  if (!isBookWithText || !textOfTheCurrentFrame || isSlideZoomed) {
    dispatch(setPreviosFrame())
  } else {
    dispatch(prevPieceOfText())
  }
}

export const nextPieceOfText = () => ({
  type: ACTIONTYPES.NEXT_TEXT_AREA_PAGE
});


export const prevPieceOfText = () => ({
  type: ACTIONTYPES.PREV_TEXT_AREA_PAGE
});

export const toggleZoomSlide = () => {
  return {
    type: ACTIONTYPES.TOGGLE_ZOOM_AREA,
  };
};




// WEBPACK FOOTER //
// ./src/store/actions/read-actions.js